import React, { useState } from "react";
import azkarMsaaData from "./AzkarMsaaData";
import { Container } from "../../Container/Container";
import Navbar from "../../Navbar/Navbar";
import AzkarList from "../../AzkarList/AzkarList";
import Wird from "../../Wird/Wird";

function AzkarMsaa() {
  const [counter1, setCounter1] = useState(0);
  const [counter2, setCounter2] = useState(0);

  // Counts
  const Count1 = () => {
    setCounter1(counter1 + 1);
  };
  const Count2 = () => {
    setCounter2(counter2 + 1);
  };

  // Resets
  const Reset1 = () => {
    setCounter1(0);
  };

  const Reset2 = () => {
    setCounter2(0);
  };

  return (
    <>
      <Navbar brand={azkarMsaaData.brand} />
      <Container>
        <AzkarList List={azkarMsaaData.List} />
        <Wird
          title={azkarMsaaData.wirdList[0].title}
          counter={counter1}
          count={Count1}
          reset={Reset1}
          text={azkarMsaaData.wirdList[0].text}
        />
        <Wird
          title={azkarMsaaData.wirdList[1].title}
          counter={counter2}
          count={Count2}
          reset={Reset2}
          text={azkarMsaaData.wirdList[1].text}
        />
      </Container>
    </>
  );
}

export default AzkarMsaa;
